<template>
  <div class="right_box_main">

    <div class="card-box">
      <div class="mapBox">
        <div
          id="map"
          ref="mapdt"
        ></div>
      </div>
      <div class="listBox">
        <div class="listBox-item">
          <el-card>
            <el-row
              class="title-col"
              style="margin-bottom:6px;font-size:14px;"
              type="flex"
              justify="space-between"
            >
              <el-col>
                编号：
                <el-input
                  type="text"
                  size="mini"
                  v-model="searchlist.eventNumber"
                  style="width:130px;"
                  clearable
                  placeholder="事件编号"
                />&nbsp;&nbsp;
                上报人：
                <el-input
                  type="text"
                  size="mini"
                  v-model="searchlist.launch"
                  style="width:130px;"
                  clearable
                  placeholder="上报人姓名"
                />&nbsp;&nbsp;
                状态：
                <el-select
                  size="mini"
                  v-model="searchlist.approvalStatus"
                  placeholder="事件状态"
                  style="width:130px"
                  clearable
                >
                  <el-option
                    v-for="item in statusMap"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>&nbsp;&nbsp;
                类型：
                <el-select
                  v-model="searchlist.eventType"
                  style="width:150px;"
                  placeholder="请选择"
                  size="mini"
                >
                  <el-option
                    v-for="item in EventTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    clearable
                  ></el-option>
                </el-select>
                <!-- <el-cascader
                                    size="mini"
                                    :options="typeMap"
                                    v-model="searchlist.type"
                                    style="width:170px"
                                    :props="{ checkStrictly: true }"
                                    clearable
                                ></el-cascader>-->
                <!-- <el-select size="mini" v-model="searchlist.eventGroup" placeholder="--事件类型--" style="width:130px" >
                    <el-option v-for="item in typeMap" 
                      :key="item.value" :label="item.label" :value="item.value"></el-option>
                                </el-select>-->
              </el-col>
            </el-row>
            <el-row
              class="title-col"
              style="margin-bottom:10px;font-size:14px;"
              type="flex"
              justify="space-between"
            >
              <el-col>
                来源：
                <el-select
                  size="mini"
                  v-model="searchlist.eventSource"
                  placeholder="事件来源"
                  style="width:130px"
                >
                  <el-option
                    v-for="item in sourceMap"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>&nbsp;&nbsp;
                上报时间：
                <el-date-picker
                  v-model="searchlist.createDate"
                  value-format="yyyy-MM-dd"
                  size="mini"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                ></el-date-picker>&nbsp;&nbsp;
                <el-button
                  size="mini"
                  type="primary"
                  @click="searchlistdata"
                >查询</el-button>&nbsp;
                <el-button
                  size="mini"
                  type="info"
                  @click="searchlistReset"
                >重置</el-button>
              </el-col>
            </el-row>
            <el-row
              class="title-col"
              style="margin-bottom:6px;"
              type="flex"
              justify="space-between"
            >
              <el-col>
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-plus"
                  @click="showDialog('add')"
                >新增</el-button>
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="deleteRows"
                >删除</el-button>
                <el-button
                  size="mini"
                  type="warning"
                  icon="el-icon-download"
                  @click="createExcel"
                >导出</el-button>
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-finished"
                  @click="funDialogShow('unreal',0)"
                  v-if="orgLevel!==4"
                >虚拟事件</el-button>
                <el-button
                  size="mini"
                  type="success"
                  icon="el-icon-circle-close"
                  @click="funDialogShow('cancel',0)"
                  v-if="orgLevel!==4"
                >作废事件</el-button>
              </el-col>
            </el-row>
            <el-table
              ref="singleTable"
              :data="tableData"
              :header-cell-style="{ background: '#f8fafa' }"
              size="mini"
              border
              align="center"
              current-row-key
              highlight-current-row
              @current-change="eventNumberClick"
              @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                align="center"
                width="50"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="eventNumber"
                width="160"
                label="事件编号"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="orgName"
                width="130"
                label="处理单位"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="personName"
                width="100"
                label="处理人员"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="launch"
                width="100"
                label="上报人"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="eventSource"
                width="120"
                label="事件来源"
              ></el-table-column>
              <el-table-column
                prop="eventDescribe"
                width="300"
                label="事件描述"
              >
                <template slot-scope="scope">
                  <p
                    :title="scope.row.eventDescribe"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.eventDescribe}}</p>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="createDate"
                width="160"
                label="登记时间"
              ></el-table-column>
              <el-table-column
                align="center"
                width="120"
                prop="eventTypeName"
                label="大类名称"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="eventGroupName"
                width="150"
                label="小类名称"
              >
                <template slot-scope="scope">
                  <p
                    :title="scope.row.eventGroupName"
                    style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;"
                  >{{scope.row.eventGroupName}}</p>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                :formatter="formatter"
                prop="approvalStatus"
                label="事件状态"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="deadline"
                width="160"
                label="到期时间"
              ></el-table-column>
              <el-table-column
                align="center"
                prop="createDate"
                width="70"
                label="是否逾期"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.overdue ==1">
                    <el-tag type="danger">是</el-tag>
                  </span>
                  <span v-else>
                    <el-tag>否</el-tag>
                  </span>
                </template>
              </el-table-column>
              <!--  -->
              <el-table-column
                align="center"
                label="操作"
                width="100"
                fixed="right"
              >
                <!-- <template slot-scope="scope">
                                    <el-tooltip
                                        class="item"
                                        effect="light"
                                        content="编辑"
                                        placement="top-start"
                                        v-if="scope.row.approvalStatus == '1'"
                                    >
                                        <button
                                            class="el-icon-edit-outline tabBtn tabBtn-edit"
                                            v-permission="{sign:'sj:sjlb:update'}"
                                            @click="showDialog('edit',scope.row)"
                                        ></button>
                                    </el-tooltip>
                                </template>-->
                <template slot-scope="scope">
                  <el-tooltip
                    class="item"
                    effect="light"
                    content="领取"
                    placement="top-start"
                    v-if="scope.row.approvalStatus == '13'"
                  >
                    <button
                      class="el-icon-circle-check tabBtn tabBtn-edit"
                      @click="showDialog('receive',scope.row)"
                    ></button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pageConfig.pageNo"
              :page-size="pageConfig.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="pageConfig.total"
            ></el-pagination>
          </el-card>
        </div>
        <!-- 详情 -->
        <div
          class="listBox-item"
          id="detailBox"
          style="height:350px;overflow:hidden;"
        >
          <el-card>
            <el-row>
              <el-col style="width:250px;margin-top: 14px;">
                <el-image
                  style="width: 100%;"
                  :src="detail.eventFile1?detail.eventFile1[0]:''"
                  fit="cover"
                  :preview-src-list="detail.eventFile1?[detail.eventFile1[0]]:[]"
                >
                  <div
                    slot="error"
                    class="image-slot"
                  >
                    <p style="text-align:center">暂无封面图,请在附件信息查看</p>
                    <i
                      style="font-size:250px"
                      class="el-icon-picture-outline"
                    ></i>
                  </div>
                </el-image>
                <!-- <img
                                    style="width: 100%;"
                                    :src="detail.eventFile1?detail.eventFile1[0]:''"
                                    preview="index3"
                                />-->
                <!-- <img
                                    class="left-img"
                                    :src="detail.eventFile1[0]"
                                />-->
              </el-col>
              <el-col style="width:calc(100% - 250px);padding-left:30px;box-sizing: border-box;">
                <el-tabs v-model="detailActiveName">
                  <el-tab-pane
                    class="detailInfo"
                    label="详细信息"
                    name="first"
                  >
                    <el-row
                      type="flex"
                      justify="space-between"
                    >
                      <el-col :span="12">事件编号：{{detail.eventNumber}}</el-col>
                      <el-col :span="12">问题来源：{{detail.eventSource}}</el-col>
                    </el-row>
                    <el-row
                      type="flex"
                      justify="space-between"
                    >
                      <el-col :span="12">大类名称：{{detail.eventTypeName}}</el-col>
                      <el-col :span="12">小类名称：{{detail.eventGroupName }}</el-col>
                    </el-row>
                    <el-row>
                      事件问题描述：
                      <span style="line-height:20px;display: inline-block;">{{detail.eventDescribe}}</span>
                    </el-row>
                    <el-row>事件地址：{{detail.addressDetail}}</el-row>
                    <el-row
                      type="flex"
                      justify="space-between"
                    >
                      <el-col :span="12">事件状态：{{formatter(detail)}}</el-col>
                      <el-col :span="12">上报人：{{detail.launch}}</el-col>
                    </el-row>
                    <el-row>上报时间：{{detail.createDate}}</el-row>
                    <el-row
                      type="flex"
                      justify="space-between"
                    >
                      <el-col :span="12">结案时间：{{detail.handleTime}}</el-col>
                      <el-col :span="12">事件处理人：{{detail.personName}}</el-col>
                    </el-row>
                    <!-- <el-row>事件处理意见：{{detail.completeReason}}</el-row> -->
                  </el-tab-pane>
                  <el-tab-pane
                    label="处理流程"
                    name="second"
                  >
                    <div
                      class="block"
                      style="padding:2px;"
                    >
                      <el-timeline>
                        <el-timeline-item
                          v-for="(item,index) in detail.logs"
                          :key="index"
                          :color="index==0?'#66b1ff':''"
                          :timestamp="item.createDate"
                          placement="top"
                        >
                          <el-card>
                            <h4>{{item.title}}</h4>
                            <p>{{item.content}}</p>
                            <p>备注：{{item.opinion?item.opinion:'无'}}</p>
                          </el-card>
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane
                    label="附件信息"
                    name="third"
                  >
                    <el-row :gutter="20">
                      <el-col :span="12">
                        <span class="demonstration">整改前</span>
                        <el-carousel
                          height="250px"
                          :autoplay="false"
                        >
                          <el-carousel-item
                            v-for="item in detail.eventFile1"
                            :key="item.id"
                          >
                            <img
                              v-show="item.substring(item.lastIndexOf('.')+1) == 'jpg' || item.substring(item.lastIndexOf('.')+1) =='png'"
                              preview="index"
                              style="width:100%"
                              :src="item"
                              alt
                            />
                            <video
                              style="width:100%;height:100%;"
                              v-if="item.substring(item.lastIndexOf('.')+1) == 'mp4'"
                              :src="item"
                              controls="controls"
                            ></video>
                            <!-- <audio
                                                            type="audio/mpeg"
                                                            :src="item"
                                                            controls="controls"
                                                        ></audio>-->
                            <audio
                              style="width:100%;height:100%;"
                              v-if="item.substring(item.lastIndexOf('.')+1) == 'mp3'"
                              controls
                            >
                              <source
                                :src="item"
                                type="audio/mpeg"
                              />
                            </audio>
                          </el-carousel-item>
                        </el-carousel>
                      </el-col>
                      <el-col :span="12">
                        <span class="demonstration">整改后</span>
                        <el-carousel
                          height="250px"
                          :autoplay="false"
                        >
                          <el-carousel-item
                            v-for="item in detail.eventFile2"
                            :key="item.id"
                          >
                            <!-- <el-image
                                                            style="width: 100%;height: 100%;"
                                                            :src="item"
                                                            fit="contain"
                                                            :preview-src-list="detail.eventFile1"
                                                        ></el-image>-->
                            <!-- {{item.substring(item.lastIndexOf('.')+1)}} -->
                            <img
                              v-show="item.substring(item.lastIndexOf('.')+1) == 'jpg' || item.substring(item.lastIndexOf('.')+1) =='png'"
                              preview="index2"
                              style="width:100%"
                              :src="item"
                              alt
                            />
                            <video
                              style="width:100%;height:100%;"
                              v-if="item.substring(item.lastIndexOf('.')+1) == 'mp4'"
                              :src="item"
                              controls="controls"
                            ></video>
                            <!-- <audio
                                                            type="audio/mpeg"
                                                            :src="item"
                                                            controls="controls"
                                                        ></audio>-->
                            <audio
                              style="width:100%;height:100%;"
                              v-if="item.substring(item.lastIndexOf('.')+1) == 'mp3'"
                              controls
                            >
                              <source
                                :src="item"
                                type="audio/mpeg"
                              />
                            </audio>
                          </el-carousel-item>
                        </el-carousel>
                      </el-col>
                    </el-row>
                  </el-tab-pane>
                </el-tabs>
              </el-col>
            </el-row>
          </el-card>
        </div>
      </div>

      <!-- 弹出框编辑 -->
      <el-dialog
        class="newDialog"
        center
        :title="addDialog.title"
        :visible.sync="addDialog.off"
        width="800px"
      >
        <el-form
          label-position="right"
          size="mini"
          label-width="120px"
          :model="addDialog.form"
          :rules="rules"
          ref="ruleForm"
        >
          <el-form-item label="事件编号:">
            <el-input
              disabled
              v-model="addDialog.form.eventNumber"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="事件来源:"
            prop="eventSource"
          >
            <el-select
              v-model="addDialog.form.eventSource"
              style="width:100%;"
              placeholder="请选择"
            >
              <el-option
                v-for="item in sourceMap"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="联系号码:"
            prop="phone"
          >
            <el-input
              placeholder="请输入手机号"
              v-model="addDialog.form.phone"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="事件分类大类:"
            prop="eventType"
          >
            <!-- <el-cascader
                            :options="typeMap"
                            v-model="addDialog.form.eventType"
                            style="width:100%;"
                            :show-all-levels="false"
                        ></el-cascader>-->
            <el-select
              v-model="addDialog.form.eventType"
              style="width:100%;"
              placeholder="请选择"
              @change="getEventGroup"
            >
              <el-option
                v-for="item in EventTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                clearable
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="事件分类小类:"
            prop="eventGroup"
          >
            <el-select
              v-model="addDialog.form.eventGroup"
              style="width:100%;"
              placeholder="请选择"
            >
              <el-option
                v-for="(item,index) in EventGroupList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="处理部门:" prop="orgId">
                        <el-cascader
                            ref="orgName"
                            size="mini"
                            v-model="addDialog.form.orgId"
                            :options="orgTree"
                            :show-all-levels="false"
                            placeholder="请选择所属网格"
                            style="width:250px"
                            clearable
                            @change="getUser"
                        ></el-cascader>
                        <el-select
                            v-model="addDialog.form.personId"
                            placeholder="请选择人员"
                            size="mini"
                        >
                            <el-option
                                v-for="item in userOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>-->
          <el-form-item
            label="事件地址:"
            prop="addressDetail"
          >
            <maplocation
              :data="mapData"
              :disabled="false"
              :on-success="mapSuccess"
              v-if="mapOff"
            />
            <!-- <el-input placeholder="请输入..." v-model="addDialog.form.eventPosition"></el-input> -->
          </el-form-item>
          <el-form-item
            label="上传图片、视频："
            prop="enclosure"
          >
            <upimgs
              @offFalse="up_off = false"
              :off="up_off"
              v-model="addDialog.form.enclosure"
              Separate=","
            />
          </el-form-item>
          <el-form-item
            label="事件情况描述:"
            prop="eventDescribe"
          >
            <el-input
              type="textarea"
              v-model="addDialog.form.eventDescribe"
              :rows="2"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            size="small"
            style="margin: 0 30px"
            @click="saveData"
          >确定</el-button>
          <el-button
            type="info"
            size="small"
            @click="addDialog.off = false"
          >取消</el-button>
        </span>
      </el-dialog>

      <!-- 弹出框虚拟/作废 -->
      <el-dialog
        class="newDialog"
        :title="funDialog.title"
        :visible.sync="funDialog.off"
        width="600px"
        center
        :before-close="clearaFunDialog"
      >
        <el-form
          label-position="right"
          label-width="120px"
          :model="funDialog.form"
        >
          <el-form-item label="事件编号:">
            <el-input
              disabled
              v-model="funDialog.form.eventNumber"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-show="funDialog.type != 'convey'"
            :label="funDialog.funName"
          >
            <el-input
              type="textarea"
              v-model="funDialog.form.virtualReason"
              :rows="4"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            size="small"
            style="margin: 0 30px"
            @click="funDialogClick"
          >确定</el-button>
          <el-button
            type="info"
            size="small"
            @click="clearaFunDialog"
          >取消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
const funMap = {}
import {
  insertProofOfEstablishment,
  listProofOfEstablishment,
  updateProofOfEstablishment,
  deleteProofOfEstablishment,
  getProofOfEstablishment,
  uplodfiles,
  requresUrl,
  examine,
  post,
} from "../../../api/requrestHttp.js"
import AMap from "AMap" // 引入高德地图
import request from "../../../utils/request.js"
import request2 from "../../../utils/request2.js"
import maplocation from "@/components/mapLocation/index.vue"
import upimgs from "@/components/uploadImgs/index.vue"
import { validatePhoneNum } from "@/utils/validate.js"
let token = JSON.parse(window.localStorage.getItem("user"))
let infoWindow
let map
let marker
export default {
  components: { maplocation, upimgs },
  data() {
    var checkMap = (rule, value, callback) => {
      if (this.mapData.addressDetail) {
        callback()
      } else {
        callback(new Error("请选择地址"))
      }
    }
    return {
      searchlist: {
        createDate: [],
      },
      //事件状态
      statusMap: [],
      //事件类型
      typeMap: [],
      //事件来源
      sourceMap: [],
      //表格数据
      multipleSelection: [],
      tableData: [],
      pageConfig: {
        pageSize: 5,
        total: 0,
        pageNo: 1,
      },
      detailActiveName: "first",
      addDialog: {
        form: {},
        off: false,
        title: "",
        type: "",
      },
      funDialog: {
        form: {
          info: "",
          approvalStatus: "",
          id: "",
        },
        off: false,
        title: "",
        type: "",
        funName: "",
      },
      detail: {},
      defaultImg: require("../../../assets/images/twoNetworkConvergence/ceshi1.png"),
      uploadUrl: requresUrl + "/eventUpload/info/uplodfiles",
      fileList: [],
      //地图标记对象
      mapMarker: {
        lng: "117.49426",
        lat: "30.656587",
        title: "事件编码",
        extDataName: "事件编码",
        extDataDesc: "事件地址",
      },
      eventType: [],
      eventClickNum: 0,
      mapOff: true,
      mapData: {
        addressDetail: "",
        areaId: null,
        cityId: null,
        latitude: 0,
        longitude: 0,
        streetId: null,
      },
      up_off: true,
      EventTypeList: [],
      EventGroupList: [],
      orgTree: [],
      userOptions: [],
      rules: {
        eventSource: [
          {
            required: true,
            message: "请选择事件来源",
            trigger: "blur",
          },
        ],
        eventType: [
          {
            required: true,
            message: "请选择事件大类",
            trigger: "blur",
          },
        ],
        eventGroup: [
          {
            required: true,
            message: "请选择事件小类",
            trigger: "blur",
          },
        ],
        eventDescribe: [
          {
            required: true,
            message: "请输入事件描述",
            trigger: "blur",
          },
        ],
        enclosure: [
          {
            required: true,
            message: "请上传事件图片",
            trigger: "blur",
          },
        ],
        phone: [
          {
            validator: validatePhoneNum,
            trigger: "blur",
            required: true,
          },
        ],
        addressDetail: [
          { validator: checkMap, trigger: "blur", required: true },
        ],
      },
      swiperOption: {
        // 参数选项,显示小点
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      orgLevel: "",
    }
  },
  methods: {
    getOrgLevel() {
      post("admin/user/info/getLoginUserInfo", {
        id: this.$store.state.id,
      }).then((res) => {
        if (res.code == 200) {
          // this.userName=res.content.user.name;
          this.orgLevel = res.content.user.orgLevel
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //条件查询
    searchlistdata() {
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    searchlistReset() {
      this.searchlist = {
        createDate: [],
      }
      this.pageConfig.pageNo = 1
      this.getPageDatas()
    },
    //分页
    handleCurrentChange(val) {
      this.pageConfig.pageNo = val
      this.getPageDatas()
    },
    async getPageDatas() {
      this.searchlist.pageNo = this.pageConfig.pageNo
      this.searchlist.pageSize = this.pageConfig.pageSize
      try {
        this.searchlist.startTime = this.searchlist.createDate[0]
          ? this.searchlist.createDate[0] + " 00:00:00"
          : ""
        this.searchlist.endTime = this.searchlist.createDate[1]
          ? this.searchlist.createDate[1] + " 23:59:59"
          : ""
      } catch (error) {
        this.searchlist.startTime = ""
        this.searchlist.endTime = ""
      }
      let params = JSON.stringify({ ...this.searchlist, createDate: "" })
      console.log(params)
      var res = await request({
        url: "/admin/event/info/listEvent",
        method: "POST",
        data: params,
      })
      if (res.code == 200 && res.content != null) {
        this.pageConfig.total = res.content.count
        this.tableData = res.content.list

        //默认选中table状态
        this.$refs.singleTable.setCurrentRow(res.content.list[0])
      } else {
        this.$message({
          message: "数据加载异常：",
          type: "error",
        })
        this.$nextTick(() => {
          this.initMap()
        })
      }
    },
    initMap() {
      // marker.set
      // if (this.mapMarker.lng != "" && this.mapMarker.lat != "") {
      //     marker.setPosition([this.mapMarker.lng, this.mapMarker.lat]);
      //     map.setFitView();
      // }
      map.remove(marker)
      if (this.mapMarker.lng != "" && this.mapMarker.lat != "") {
        marker = new AMap.Marker({
          position: [this.mapMarker.lng, this.mapMarker.lat], // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          title: this.mapMarker.title,
          extData: {
            name: this.mapMarker.extDataName,
            desc: this.mapMarker.extDataDesc,
          },
          map: map,
        })
        map.setFitView(marker)
      } else {
        AMap.plugin("AMap.Geolocation", function () {
          //异步定位当前
          var geolocation = new AMap.Geolocation()
          map.addControl(geolocation)
        })
      }
      // 绑定事件
      marker.on("click", function (e) {
        if (!infoWindow) {
          infoWindow = new AMap.InfoWindow({ autoMove: true })
        }
        var extData = e.target.getExtData()
        // console.log(extData);
        infoWindow.setContent(
          "<div style='width: 230px;'>" +
            extData.name +
            "<br/>" +
            extData.desc +
            "</div>"
        )
        infoWindow.open(map, e.lnglat)
      })
    },
    //导出excel
    async createExcel() {
      this.$delete(this.searchlist, "pageSize")
      this.$delete(this.searchlist, "pageNo")
      this.searchlist.pageNo = this.pageConfig.pageNo
      this.searchlist.pageSize = this.pageConfig.pageSize
      this.searchlist.startTime = this.searchlist.createDate[0]
        ? this.searchlist.createDate[0]
        : ""
      this.searchlist.endTime = this.searchlist.createDate[1]
        ? this.searchlist.createDate[1]
        : ""
      let params = JSON.stringify({ ...this.searchlist, createDate: "" })
      var res = await request2({
        url: "/admin/event/info/exportEvent",
        method: "POST",
        data: params,
        responseType: "blob",
      })
      const blob = new Blob([res], { type: "application/vnd.ms-excel" })
      const fileName = "事件列表.xls"
      const linkNode = document.createElement("a")

      linkNode.download = fileName //a标签的download属性规定下载文件的名称
      linkNode.style.display = "none"
      linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
      document.body.appendChild(linkNode)
      linkNode.click() //模拟在按钮上的一次鼠标单击

      URL.revokeObjectURL(linkNode.href) // 释放URL 对象
      document.body.removeChild(linkNode)
    },
    async deleteRows() {
      if (this.multipleSelection.length < 1) {
        this.$message({
          message: "请先选择您要删除的数据项",
          type: "error",
        })
        return
      }
      this.$confirm("此操作将删除您选中的数据项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let ids = []
          this.multipleSelection.forEach((item) => {
            ids.push(item.id)
          })
          let params = JSON.stringify({ ids: ids })
          // console.log(params)
          // return
          var res = await request({
            url: "/admin/event/info/batchDeleteEvent",
            method: "POST",
            data: params,
          })
          if (res.code == 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            })
            this.pageConfig.pageNo = 1
            this.getPageDatas()
          } else {
            console.log(res)
            this.$message({
              message: "删除失败：" + res.message,
              type: "error",
            })
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },

    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    funDialogShow(flag) {
      if (this.multipleSelection.length != 1) {
        this.$message({
          message: "请选择一条数据进行操作",
          type: "error",
        })
        return
      }
      let rowdata = this.multipleSelection[0]
      if (
        rowdata.approvalStatus == 10 ||
        rowdata.approvalStatus == 11 ||
        rowdata.approvalStatus == 12 ||
        rowdata.approvalStatus == 14 ||
        rowdata.approvalStatus == 5
      ) {
        this.$message({
          message: "请选择一条正确数据进行操作",
          type: "error",
        })
        return
      }
      this.funDialog.form.info = ""
      this.funDialog.off = true

      this.funDialog.title = "事件编号:" + rowdata.eventNumber
      this.funDialog.form.eventNumber = rowdata.eventNumber
      this.funDialog.form.id = rowdata.id
      this.funDialog.type = flag
      switch (flag) {
        case "unreal":
          this.funDialog.funName = "虚假原由："
          this.funDialog.form.approvalStatus = "11"
          break
        case "cancel":
          this.funDialog.funName = "作废原由："
          this.funDialog.form.approvalStatus = "8"
          break
        default:
          break
      }
    },
    funDialogClick() {
      updateProofOfEstablishment(this.funDialog.form)
        .then((res) => {
          this.$message({
            message: res.message,
            type: "success",
          })
          this.funDialog.off = false
          this.getPageDatas()
        })
        .catch(function (error) {
          console.log(error)
        })
      // examine()
      //     .then(res => {
      //         this.$message({
      //             message: res.message,
      //             type: "success"
      //         });
      //         this.getPageDatas();
      //     })
      //     .catch(function(error) {
      //         console.log(error);
      //     });
    },
    clearaFunDialog() {
      this.funDialog.off = false
    },
    //获取人员
    getUser(value) {
      this.userOptions = []
      this.addDialog.form.personId = ""
      post("/admin/user/info/list", {
        orgId: this.addDialog.form.orgId[this.addDialog.form.orgId.length - 1],
        pageNo: 1,
        pageSize: 99,
      }).then((res) => {
        res.content.list.forEach((e) => {
          this.userOptions.push({
            value: e.id,
            label: e.name,
          })
        })
      })
    },
    getUsers(id) {
      this.userOptions = []
      post("/admin/user/info/list", {
        orgId: id,
        pageNo: 1,
        pageSize: 99,
      }).then((res) => {
        res.content.list.forEach((e) => {
          this.userOptions.push({
            value: e.id,
            label: e.name,
          })
        })
      })
    },
    //获取小类
    getEventGroup(value) {
      this.EventGroupList = []
      this.addDialog.form.eventGroup = ""
      post("/admin/event/info/getEventGroup", {
        parentId: this.addDialog.form.eventType,
        pageNo: 1,
        pageSize: 99,
      }).then((res) => {
        res.content.forEach((e) => {
          this.EventGroupList.push({
            value: e.dictId,
            label: e.dictName,
          })
        })
      })
    },
    //坐标获取成功
    mapSuccess(info) {
      this.mapData = info
    },
    showDialog(type, form) {
      this.up_off = true
      if (type == "add") {
        this.addDialog.off = true
        this.fileList = []
        this.addDialog.type = type
        this.addDialog.title = "登记事件"
        this.addDialog.form = {
          personId: "",
          eventGroup: "",
        }
        this.mapData = {
          addressDetail: "",
          areaId: null,
          cityId: null,
          latitude: 0,
          longitude: 0,
          streetId: null,
        }
        this.mapOff = false
        this.$nextTick(() => {
          this.mapOff = true
        })
      } else if (type == "receive") {
        this.$confirm("此操作将领取该事件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then((res) => {
            this.addDialog.form = JSON.parse(JSON.stringify(form))
            console.log(form)
            // updateProofOfEstablishment({
            //     id:this.addDialog.form.id,
            //     personId: this.$store.state.info.id,
            // })
            //     .then(res => {
            //         this.$message({
            //             message: '领取成功！',
            //             type: "success"
            //         });
            //         this.getPageDatas();
            //     })
            //     .catch(function(error) {
            //         console.log(error);
            //     });
            post("/admin/event/info/updateEvent", {
              ...this.addDialog.form,
              personId: this.$store.state.info.id,
              approvalStatus: "4",
            }).then((res) => {
              this.$message({
                message: "领取成功",
                type: "success",
              })

              this.getPageDatas()
            })
          })
          .catch((error) => {})
      } else {
        this.addDialog.off = true
        this.addDialog.type = type
        this.addDialog.title = "修改事件"
        this.addDialog.form = JSON.parse(JSON.stringify(form))
        this.mapData.addressDetail = this.addDialog.form.addressDetail
        this.mapData.areaId = this.addDialog.form.areaId
        this.mapData.cityId = this.addDialog.form.cityId
        this.mapData.latitude = this.addDialog.form.latitude
        this.mapData.longitude = this.addDialog.form.longitude
        this.mapData.streetId = this.addDialog.form.streetId
        this.addDialog.form.orgId = this.addDialog.form.orgId + ""
        this.getUsers(this.addDialog.form.orgId)
        // this.addDialog.form.personId = this.addDialog.form.personId+;
        this.mapOff = false
        this.$nextTick(() => {
          this.mapOff = true
        })
      }
    },
    saveData() {
      let that = this
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          that.submit()
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    submit() {
      if (this.addDialog.type == "add") {
        post("/admin/event/info/insertEvent", {
          ...this.addDialog.form,
          ...this.mapData,
          createId: this.$store.state.info.id,
          launch: this.$store.state.info.name,
          approvalStatus: 1,
        }).then((res) => {
          this.$message({
            message: res.message,
            type: "success",
          })
          this.addDialog.off = false
          this.getPageDatas()
        })
      } else {
        updateProofOfEstablishment({
          ...this.addDialog.form,
        })
          .then((res) => {
            this.$message({
              message: res.message,
              type: "success",
            })
            this.addDialog.off = false
            this.getPageDatas()
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    async eventNumberClick(rowVal) {
      if (!rowVal) {
        this.detail.eventFile1 = []
        this.detail.eventFile2 = []
        this.detail = {}
        this.mapMarker.lng = "117.49426"
        this.mapMarker.lat = "30.656587"
        this.mapMarker.extDataName = "无"
        this.mapMarker.extDataDesc = "无"
        this.$nextTick(() => {
          this.initMap()
        })
        return false
      }
      this.eventClickNum = this.eventClickNum + 1
      let params = JSON.stringify({ id: rowVal.id })
      var res = await request({
        url: "/admin/event/info/getEvent",
        method: "POST",
        data: params,
      })
      if (res.code == 200) {
        // console.log(res.content)
        this.detail = res.content
        this.detail.statusName = this.formatter(res.content.approvalStatus)
        //  var arr = res.content.enclosure.split(",");
        // this.detail.enclosure = [];
        this.detail.eventFile1 = []
        this.detail.eventFile2 = []
        res.content.eventFile.forEach((val) => {
          if (val.state == "1") {
            this.detail.eventFile1.push(val.url)
          } else {
            this.detail.eventFile2.push(val.url)
          }
        })
        //临时赋值
        // res.content.eventFile = [
        // ];

        // res.content.eventFile.forEach(item => {
        //     if (item.url != "") {
        //         if (item.state == 1) {
        //             this.detail.eventFile1.push(item);
        //         } else {
        //             this.detail.eventFile2.push(item);
        //         }
        //     }
        // });
        //处理流程
        this.detail.logs = res.content.eventProcessList
        this.mapMarker.title = res.content.eventNumber
        if (res.content.longitude) {
          this.mapMarker.lng = res.content.longitude
          this.mapMarker.lat = res.content.latitude
        } else {
          this.mapMarker.lng = "117.49426"
          this.mapMarker.lat = "30.656587"
        }
        this.mapMarker.extDataName = res.content.eventDescribe
        this.mapMarker.extDataDesc = res.content.addressDetail
        this.$nextTick(() => {
          this.initMap()
        })
        if (this.eventClickNum > 1) {
          // document.getElementById("detailBox").scrollIntoView();
        }
      } else {
        this.$message({
          message: "获取数据异常",
          type: "error",
        })
      }
    },

    formatter(row, column) {
      let statusName = ""
      this.statusMap.forEach((item) => {
        if (row.approvalStatus == item.value) {
          statusName = item.label
        }
      })
      return statusName
    },
  },
  mounted() {
    this.getOrgLevel()
    map = new AMap.Map("map", {
      resizeEnable: true,
      zoom: 15,
      keyboardEnable: false,
      doubleClickZoom: false,
    })
    if (this.mapMarker.lng != "" && this.mapMarker.lat != "") {
      marker = new AMap.Marker({
        position: [this.mapMarker.lng, this.mapMarker.lat], // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        title: this.mapMarker.title,
        extData: {
          name: this.mapMarker.extDataName,
          desc: this.mapMarker.extDataDesc,
        },
        map: map,
      })
      map.setFitView(marker)
    } else {
      AMap.plugin("AMap.Geolocation", function () {
        //异步定位当前
        var geolocation = new AMap.Geolocation()
        map.addControl(geolocation)
      })
    }
    // 绑定事件
    marker.on("click", function (e) {
      if (!infoWindow) {
        infoWindow = new AMap.InfoWindow({ autoMove: true })
      }
      var extData = e.target.getExtData()
      // console.log(extData);
      infoWindow.setContent(
        "<div style='width: 230px;'>" +
          extData.name +
          "<br/>" +
          extData.desc +
          "</div>"
      )
      infoWindow.open(map, e.lnglat)
    })
    this.statusMap = [
      { value: 1, label: "待批转" },
      // { value: 2, label: "撤销中" },
      // { value: 3, label: "已撤销" },
      { value: 4, label: "已接收" },
      { value: 5, label: "结案中" },
      { value: 6, label: "延期中" },
      { value: 7, label: "回退中" },
      { value: 8, label: "作废中" },
      { value: 9, label: "已回访" },
      { value: 10, label: "已作废" },
      { value: 11, label: "已虚拟" },
      { value: 13, label: "待领取" },
      { value: 14, label: "已结案" },
      { value: 15, label: "已延期" },
    ]
    this.typeMap = [
      {
        value: "市容市面",
        label: "市容市面",
        children: [
          { value: "街面秩序", label: "街面秩序" },
          { value: "市容立面", label: "市容立面" },
          { value: "市容管理", label: "市容管理" },
        ],
      },
      {
        value: "环境卫生",
        label: "环境卫生",
        children: [
          { value: "环卫保洁", label: "环卫保洁" },
          { value: "环境管理", label: "环境管理" },
        ],
      },
      {
        value: "城市管理",
        label: "城市管理",
        children: [
          { value: "宣传广告", label: "宣传广告" },
          { value: "施工管理", label: "施工管理" },
          { value: "城市部件", label: "城市部件" },
        ],
      },
      { value: "其他事件", label: "其他事件" },
    ]
    this.sourceMap = [
      { value: "巡查上报", label: "巡查上报" },
      { value: "督查反馈", label: "督查反馈" },
      { value: "市长热线", label: "市长热线" },
      { value: "平台自建", label: "平台自建" },
      { value: "市民上报", label: "市民上报" },
      { value: "巡查反馈", label: "巡查反馈" },
      { value: "上级督查", label: "上级督查" },
    ]
    post("/admin/event/info/getEventType", {
      pageNo: 1,
      pageSize: 99,
    }).then((res) => {
      res.content.forEach((e) => {
        this.EventTypeList.push({
          value: e.dictId,
          label: e.dictName,
        })
      })
    })
    post("/rbac/admin/org/info/OrgTreelist", {
      orgType: "1",isValid: 1,
    }).then((res) => {
      this.orgTree = res.content
    })
    this.getPageDatas()
  },
}
</script>
<style lang="less" scoped>
.el-carousel {
  /deep/img {
    height: 100%;
    width: auto !important;
    margin: 0 auto !important;
    display: block;
  }
}
.card-box {
  float: left;
  width: 100%;
  min-height: calc(100vh - 120px);
}
.mapBox {
  float: left;
  margin-left: 10px;
  width: 300px !important;
  background-color: rgb(252, 249, 242);
  div {
    width: 300px;
    height: 100%;
  }
}
.listBox {
  float: left;
  width: calc(100% - 310px);
  display: flex;
  flex-direction: column;
}
.listBox-item {
  flex-grow: 1;
  margin: 0 10px 10px 10px;
  width: calc(100% - 20px);
  overflow: hidden;
  .el-card {
    height: 100%;
  }
  .left-img {
    width: 90%;
    margin-top: 13px;
  }
  .el-timeline {
    height: 230px;
    overflow: auto;
  }
}
.detailInfo {
  font-size: 14px;
  line-height: 2;
}
.tabBtn {
  margin: 0;
}
.title-col {
  position: relative;
  .el-dropdown {
    position: absolute;
    top: 67px;
    right: 18px;
    z-index: 99;
  }
}
.demonstration {
  line-height: 20px;
  font-size: 14px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: transparent;
}
.el-carousel__item:nth-child(2n + 1) {
  background-color: transparent;
}
#detailBox {
  margin-bottom: 0px;
  flex-grow: 5;
}
</style>
 